import ReactGA from "react-ga4";


const actionReplayEventTypes = [5, 50, 51, 100, 155, 200, 201, 202];
const gameEventsTypes = [1,2]

// Get story data from GUID 
export const getStoryData = async ({id, country, StoriesAzureAPI, debug, getVenueName, setState, state}) => {
  // Get story data depending on url (USA is using a slightly differnt system which requires a different call)
  let story = 
    await StoriesAzureAPI.get(id).then(
      response => {
        if(debug)console.log('API request response:', response);
        return response;
      }
    );
    
  // After raw Story data has been pulled we trigger getVenueName
  let venue = getVenueName(story.data.venue_code);
  let player1 = story.data.Players[0].id;

  // Get all events from story and sort them into different arrays for photos, loopcams, actionreplays and games
  let events = story.data.Newsfeed.reduce((data, event) => {
    if (gameEventsTypes.includes(event.type) || actionReplayEventTypes.includes(event.type)) {
      // Event between 50 - 250 - Action Replay. if Uri exits add it to array
      if (event.video_url !== '' && event.video_url !== null ) {
        data.actionReplays.push(event);
      }
      if (event.type == 1) {
        if(!(event.game in data.games)){ 
          data.games[event.game] = []; 
        }
        event.players = player1;
      }
      if (event.game != 'TBC' && event.game != null && (event.game in data.games)) {
          data.games[event.game].push(event);    
      }

      // }else if(event.game != 'TBC'){
      //     data.games[event.game].push(event);    
      // }
    }
    return data;
  }, {
    actionReplays: [],
    games: {}
  });
  //set up array for game events
  let gameEvents = [];
  //loop through each game type from games object
  for (let [key, game] of Object.entries(events.games)) {
    // set highscor var to black at the start of each loop
    let highscore;
    let obj;
    // switch to do different array manipulation dependant on game type
    switch(key) {
      case 'Amplifier':
        highscore = Math.max.apply(null, game.map(function(o){
          if(o.type == 2){
            return +JSON.parse(o.round_scores).slice(0, -2).sort((a, b)=>{return b - a})[0];
          }else{
            return 0
          }
        }))
        obj = game.find((o)=>{if(o.type == 2){return JSON.parse(o.round_scores).slice(0, -2).includes(highscore)}})
        if(typeof obj != "undefined" && obj.players){
          gameEvents.push(obj)
        }
        break;
      case 'Eclipse':
        highscore = Math.min.apply(null, game.map(function(o){
          if(o.type == 2){
            return +JSON.parse(o.round_scores).slice(0, -2).sort((a, b)=>{return a - b})[0];
          }else{
            return 9999
          }
        }))
        obj = game.find((o)=>{if(o.type == 2){return JSON.parse(o.round_scores).slice(0, -2).includes(highscore)}})
        if(typeof obj != "undefined" && obj.players){
          gameEvents.push(obj)
        }
        break
      case 'ShortCircuit':
        highscore = Math.min.apply(null, game.map(function(o){
          if(o.type == 2){
            return +JSON.parse(o.round_scores).slice(0, -2).sort((a, b)=>{return a - b})[0];
          }else{
            return 9999
          }
        }))
        obj = game.find((o)=>{if(o.type == 2){return JSON.parse(o.round_scores).slice(0, -2).includes(highscore)}})
        if(typeof obj != "undefined" && obj.players){
          gameEvents.push(obj)
        }
        break
      case 'Territory':
        highscore = Math.max.apply(null, game.map(function(o){
          if(o.type == 2){
            return +JSON.parse(o.round_scores).slice(0, -2).sort((a, b)=>{return b - a})[0];
          }else{
            return 0
          }
        }))
        obj = game.find((o)=>{if(o.type == 2){return JSON.parse(o.round_scores).slice(0, -2).includes(highscore)}})
        if(typeof obj != "undefined" && obj.players){
          gameEvents.push(obj)
        }
        break
      default :
        // default
      break;
    }
  }  
  let teamsPhotos = story.data.Teams.filter((e) => {
    if(e.Photo){
      return e;
    }
  })
  // Set state variables to story data and event data
  setState({
    ...state,
    guid: id,
    type: story.data.type,
    reference: story.data.reference,
    venue: venue.venue_name,
    city: venue.city_name,
    country: country,
    cityurl: venue.city_url,
    azureurl: venue.azure_url,
    bloburl: venue.blob_url,
    feedbackurl: venue.feedback_url,
    players: story.data.Players,
    teams: story.data.Teams,
    newsfeed: story.data.Newsfeed,
    actionReplays:  (story.data.type == '1' || story.data.type == '3') ? events.actionReplays.slice((events.actionReplays.length -10 < 0 ? 0 : events.actionReplays.length -10), events.actionReplays.length).reverse() : events.actionReplays,
    photos: teamsPhotos,
    games: gameEvents,
    debug: debug
  });
  // GGoogle analytics trigger open story event
  ReactGA.event({
    category: "Story opened",
    action: 's: ' + window.location.host + ' v: ' + venue.venue_name
  });
};